import React from 'react';


import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"

import LocaleMapView from "../views/locale/LocaleMapView.jsx";
import LocaleListView from "../views/locale/LocaleListView.jsx";
import LocaleViewerBar from "../views/locale/LocaleViewerBar.jsx";
import CreateLocaleDialog from "../views/locale/CreateLocaleDialog.jsx";
import EditLocaleDialog from "../views/locale/EditLocaleDialog.jsx";
import LocaleMapState from "../views/locale/LocaleMapState.jsx"
import ProgressDialog from "../views/ProgressDialog.jsx"
import * as MapTile from "../tools/MapTile.js"
import LocaleOverviewDialog from "../views/locale/LocaleOverviewDialog.jsx"
import ResourceLibraryPage from '../pages/ResourceLibraryPage.jsx';

// tmp code for react component testing

import { Box } from '@mantine/core';

// drawer width in pixel
const localeBoxMarginLeft = 180;

const VIEW_LOCALE_LIST    = 0;
const VIEW_LOCALE_MAP     = 1;
const VIEW_RESOURCE_LIBRARY = 2;

const MAX_ROW_PER_PAGE    = 12;

class LocaleViewerPage extends React.Component {
  static VIEW_LOCALE_LIST() {
    return VIEW_LOCALE_LIST;
  }
  static VIEW_LOCALE_MAP() {
    return VIEW_LOCALE_MAP;
  }

  getSteps() {
    return [Localization.strings.DETAILS, Localization.strings.LOCATION, Localization.strings.SETTINGS];
  }

  // Helper method to determine view from URL path
  getViewFromURL(path) {
    switch (path) {
      case "/list":
        return VIEW_LOCALE_LIST;
      case "/map":
        return VIEW_LOCALE_MAP;
      case "/library":
        return VIEW_RESOURCE_LIBRARY;
      default:
        return VIEW_LOCALE_LIST;
    }
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // Determine initial view based on current URL to prevent flash of incorrect content
    // Try to get React Router path, fall back to window location if not available
    let currentPath = '/list'; // default fallback
    try {
      if (props && props.root && props.root.props && props.root.props.history && props.root.props.history.location) {
        currentPath = props.root.props.history.location.pathname;
      } else {
        // Parse the hash for React Router paths
        const hash = window.location.hash;
        if (hash && hash.includes('/')) {
          const pathMatch = hash.match(/\/(list|map|library)/);
          if (pathMatch) {
            currentPath = '/' + pathMatch[1];
          }
        }
      }
    } catch (e) {
      console.warn('Could not determine React Router path in constructor, using default:', e);
    }
    
    const initialView = this.getViewFromURL(currentPath);

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},


      currentView: initialView,
      localeList: [],
      localeListInMap: [],
      // Three-state list rendering: while a list request is in flight the view
      // must not fall back to the "no result" artwork, which reads as an answer
      // the server has not given yet. Starts true because the constructor fires
      // refreshLocaleList() below.
      localeListLoading: true,
      localeZoom: 12,
      filterSchoolID: props.root.getMySchoolId(),
      filterUserID: props.root.getMyUserId(),
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
      filterKeyword: "",
      currentLocale: null,
      localeID: -1,
      localeIndex: -1,
      totalLocale: 0,
      totalPage: 0,
      currentPage: 0,
      tileLength: 0,
      isViewPublic: false,
      active: true,
      showPublicOnly: 0,
      qaState: -1,
      needsRefresh: false,
      activeFilter: 'my_locale',
      orderBy: 'date_update',
      orderMode: 'desc',
      isUserChangingView: false // Flag to track user-initiated view changes
    };
    autoBind(this);

    // refreshLocaleList() runs from here, before mount, so setLocaleListLoading
    // has to know not to call setState yet.
    this.isComponentMounted = false;

    this.localeViewerBarRef = React.createRef();
    this.refreshLocaleList();
  }

  componentDidMount() {
    // this.props.root.setTitle("LOCALE LIST !!!!")
    this.isComponentMounted = true;

    // Safety check: ensure view matches the actual React Router path
    // Use setTimeout to ensure component is fully mounted before correcting view
    setTimeout(() => {
      try {
        const actualPath = this.props.root.props.history.location.pathname;
        const expectedView = this.getViewFromURL(actualPath);
        
        if (this.state.currentView !== expectedView) {
          this.setState({ currentView: expectedView });
        }
      } catch (error) {
        console.warn('Error in componentDidMount view correction:', error);
      }
    }, 100);
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentView !== this.state.currentView) {
      // View changed - component updated
    }
  }

  // Mirrors the direct-assign + setState idiom used across this page, but stays
  // quiet before mount because the first list request is fired from the
  // constructor.
  setLocaleListLoading(loading) {
    this.state.localeListLoading = loading;
    if (this.isComponentMounted) {
      this.setState({ localeListLoading: loading });
    }
  }

  // return a string that summarize the current LOCALE searching filters
  // used for title display, return empty string if there is no filter
  getFilterString(){
    return "filter string!!";
  }

  setFilter(filter) {
    this.setState({ activeFilter: filter }, this.refreshLocaleList);
  }

  setOrderBy(orderBy) {
    this.setState({ orderBy: orderBy }, this.refreshLocaleList);
  }

  toggleOrderMode() {
    this.setState(prevState => ({
      orderMode: prevState.orderMode === 'asc' ? 'desc' : 'asc'
    }), this.refreshLocaleList);
  }

  updateMapState() {
    if (this.refs.localeMapState != null) {
      this.refs.localeMapState.updateState();
    }
  }

  changeView(view, updateHistory = true) {
    // Set flag to indicate user-initiated change
    this.setState({ isUserChangingView: true });
    this.state.isUserChangingView = true;
    
    this.updateMapState();

    // Update state
    this.setState({
      currentView: view
    });
    this.state.currentView = view;

    // Push unique URL for each view
    if (updateHistory) {
      switch (view) {
        case VIEW_LOCALE_LIST:
          this.props.root.pushHistory("/list");
          break;
        case VIEW_LOCALE_MAP:
          this.props.root.pushHistory("/map");
          break;
        case VIEW_RESOURCE_LIBRARY:
          this.props.root.pushHistory("/library");
          break;
        default:
          this.props.root.pushHistory("/list");
          break;
      }
    }

    // Always refresh data when switching to List View to ensure we have current data
    if (view === VIEW_LOCALE_LIST) {
      this.refreshLocaleList();
      this.setState({ needsRefresh: false });
    }
    
    this.forceUpdate();
    
    // Clear the flag after a short delay
    setTimeout(() => {
      this.setState({ isUserChangingView: false });
      this.state.isUserChangingView = false;
    }, 500);
  }

  // Handle view changes from URL navigation
  handleURLViewChange(path) {
    let targetView = VIEW_LOCALE_LIST; // default
    
    switch (path) {
      case "/list":
        targetView = VIEW_LOCALE_LIST;
        break;
      case "/map":
        targetView = VIEW_LOCALE_MAP;
        break;
      case "/library":
        targetView = VIEW_RESOURCE_LIBRARY;
        break;
      default:
        targetView = VIEW_LOCALE_LIST;
        break;
    }
    
    // Check if view is already correct - if so, don't change it to prevent flash
    if (this.state.currentView === targetView) {
      return;
    }
    
    // Update state immediately and directly
    this.setState({ currentView: targetView });
    this.state.currentView = targetView;
    
    // Also update the LocaleViewerBar if it exists
    if (this.refs.localeViewerBar) {
      this.refs.localeViewerBar.forceUpdate();
    }
    
    // Force a re-render to ensure the UI updates
    this.forceUpdate();
  }

  // `currentLocale` is the row captured when the locale was opened, and the
  // list response is a fresher copy of it (cover path included, since the list
  // query joins the file table). Adopting the fresh row keeps a refresh from
  // re-asserting pre-edit values into RootPage; a locale that is not in this
  // response — another page, another filter — keeps the row it already had.
  adoptFreshCurrentLocale(localeRows) {
    const current = this.state.currentLocale;
    if (!current || !Array.isArray(localeRows)) {
      return current;
    }

    const fresh = localeRows.find((row) => String(row.id) === String(current.id));
    if (!fresh) {
      return current;
    }

    this.setState({ currentLocale: fresh });
    this.state.currentLocale = fresh;
    return fresh;
  }

  // Called after a save so the cached locale reflects what was just written,
  // without waiting for a list refresh that may not even include the row.
  updateCurrentLocale(locale) {
    if (!locale) {
      return;
    }

    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
    this.props.root.setCurrentLocale(locale);
  }

  getLocaleListOK(res) {
    this.setLocaleListLoading(false);

    if (this.state.currentView == VIEW_LOCALE_MAP) {
      this.setState({localeListInMap:res.body['result']});
      this.state.localeListInMap = res.body['result'];
      this.adoptFreshCurrentLocale(res.body['result']);
      // this.props.root.setCurrentLocale(null); hot-fix
    }
    else {
      this.setState({localeList:res.body['result']});
      this.state.localeList = res.body['result'];
      this.props.root.setCurrentLocale(this.adoptFreshCurrentLocale(res.body['result']));
      let count = res.body.count;
      let page = Math.ceil(count / MAX_ROW_PER_PAGE);
      this.setState({
        totalLocale: count,
        totalPage: page,
      });
      this.state.totalLocale = count;
      this.state.totalPage = page;
    }
  }

  getLocaleListFailed(err) {
    // The list is now "known to be nothing we can show" rather than "not known
    // yet", so drop out of the loading state instead of spinning forever.
    this.setLocaleListLoading(false);
    console.log("getLocaleListFailed");
  }

  filterLocaleBySchoolAndUserId(schoolId, userId){
    this.setState({
      filterSchoolID: schoolId,
      filterUserID: userId,
    });
    this.state.filterSchoolID = schoolId;
    this.state.filterUserID = userId;

    // this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID);
  }

  filterLocaleByKLA(kla) {
    if (kla >= 0) {
      this.setState({ filterKLA: kla });
      this.state.filterKLA = kla;
    }
    this.changePage(0, false);
    // this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA);
  }

  filterLocaleBySubject(subject) {
    if (subject >= 0) {
      this.setState({ filterSubject: subject });
      this.state.filterSubject = subject;
    }
    this.changePage(0, false);
    // this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject);
  }

  filterLocaleBySubmission(ownSubmission) {
    if (ownSubmission >= 0 ) {
      this.setState({filterSubmission: ownSubmission});
      this.state.filterSubmission = ownSubmission;
    }
    this.changePage(0, false);
    // this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission);
  }

  filterLocaleByKeyword(keyword) {
    this.setState({ filterKeyword: keyword });
    this.state.filterKeyword = keyword;
    this.changePage(0, false);
    // this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission, this.state.filterKeyword);
  }

  filterLocaleList(schoolID, userID, kla, subject, own_submission, keyword) {
    // Safety check - don't proceed if user data isn't loaded yet
    if (!this.props.root.getMyUserId() || !this.props.root.getMySchoolId()) {
      console.warn('User data not loaded yet, skipping filterLocaleList');
      return;
    }
    
    this.updateMapState();
    let requestObj= {
      table: "epack",
      is_editor: "1",
      filter: {
      },
      order_by: this.state.orderBy,
      order_mode: this.state.orderMode,
    };

    switch (this.state.activeFilter) {
      case 'my_locale':
        requestObj.filter['epack.user_id'] = this.props.root.getMyUserId().toString();
        break;
      case 'school_locale':
        requestObj.filter['epack.school_id'] = this.props.root.getMySchoolId().toString();
        break;
      case 'assessment':
        requestObj["own_submission"] = 1;
        requestObj.filter["submission.school_id"] = this.props.root.getMySchoolId();
        break;
      default:
        break;
    }

    if (this.state.currentView == VIEW_LOCALE_MAP) {
      if (this.refs.localeMapState != null) {
        let bounds = this.refs.localeMapState.state.bounds;
        requestObj.filter["ul_lat"] = bounds.ul.lat;
        requestObj.filter["ul_lon"] = bounds.ul.lon;
        requestObj.filter["br_lat"] = bounds.br.lat;
        requestObj.filter["br_lon"] = bounds.br.lon;
      }
    }
    else {
      requestObj.current_page = this.state.currentPage;
      requestObj.row_per_page = MAX_ROW_PER_PAGE;
    }

    if (this.props.root.isAdminUser()) {
      requestObj["show_public_only"] = this.state.showPublicOnly;
    }

    if (this.state.qaState >= 0) {
      requestObj.filter['qa_state'] = this.state.qaState;
    }

    let api_call = "get_list_epack";

    switch (this.state.activeFilter) {
      case 'my_locale':
        api_call = "get_list_epack_by_user_id"
        requestObj = { user_id: this.props.root.getMyUserId() };
        break;
      case 'school_locale':
        api_call = "get_list_epack_by_school_id";
        requestObj = { school_id: this.props.root.getMySchoolId() };
        break;
      case 'assessment':
        api_call = "get_list_epack_has_my_sch_submission";
        requestObj = { school_id: this.props.root.getMySchoolId() };
        break;
      default:
        break;
    }

    requestObj.order_by = this.state.orderBy;
    requestObj.order_mode = this.state.orderMode;

    // Safety check for API ref
    if (!this.props.root.refs || !this.props.root.refs.API) {
      console.warn('API ref not available yet, skipping locale list request');
      return;
    }

    this.setLocaleListLoading(true);
    this.props.root.refs.API.request(api_call, requestObj, this.getLocaleListOK, this.getLocaleListFailed);
  }

  clearLocaleFilter() {
    let viewPublic = this.state.isViewPublic;
    this.changePage(0);
    this.setState({
      filterSchoolID: (viewPublic? null : this.props.root.getMySchoolId()),
      filterUserID: (viewPublic? null : this.props.root.getMyUserId()),
      filterKLA: 0,
      filterSubject: 0,
      filterKeyword: ""
    });
    this.state.filterSchoolID = (viewPublic? null : this.props.root.getMySchoolId());
    this.state.filterUserID = (viewPublic? null : this.props.root.getMyUserId());
    this.state.filterKLA = 0;
    this.state.filterSubject = 0;
    this.state.filterKeyword = "";
  }

  refreshLocaleList() {
    this.filterLocaleList(this.state.filterSchoolID, this.state.filterUserID, this.state.filterKLA, this.state.filterSubject, this.state.filterSubmission, this.state.filterKeyword);
  }

  setLocaleCenter(center) {
    this.refs.localeMapState.setCenter(center);
  }

  showLocaleInfo(index) {
    const locale = this.state.currentView == VIEW_LOCALE_MAP
      ? this.state.localeListInMap[index]
      : this.state.localeList[index];

    this.showLocaleSettings(locale, index);
  }

  showLocaleSettings(locale, index = null) {
    if (!locale) {
      return;
    }

    this.props.root.setCurrentLocale(locale);
    this.refs.editLocaleDialog.setState({open: true});
    if (index !== null) {
      this.setState({ localeIndex: index });
      this.state.localeIndex = index;
    }
  }

  overviewLocale(index) {
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      this.props.root.setCurrentLocale(this.state.localeListInMap[index]);
    }
    else {
      this.props.root.setCurrentLocale(this.state.localeList[index]);
    }

    this.refs.overviewLocaleDialog.refresh();
    this.refs.overviewLocaleDialog.setState({
      open: true,
      localeIndex: index,
    });
    this.refs.overviewLocaleDialog.state.open = true;
  }

  editLocaleByIndex(index) {
    let locale = null;
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      locale = this.state.localeListInMap[index];
    }
    else {
      locale = this.state.localeList[index];
    }
    this.setState({ localeIndex: index });
    this.state.localeIndex = index;

    this.editLocale(locale);
  }

  editLocale(locale, changeHistory=true) {
    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
    this.props.root.setCurrentLocale(locale);
    this.props.root.changeStatus(this.props.parent.STATUS_VIEW_HOTSPOT());

    if (changeHistory) {
      this.props.root.pushHistory("locale/hotspot", {locale: locale});
    }
  }

  retrieveAnswerByIndex(index) {
    let locale = null;
    if (this.state.currentView == VIEW_LOCALE_MAP) {
      locale = this.state.localeListInMap[index];
    }
    else {
      locale = this.state.localeList[index];
    }

    this.retrieveAnswer(locale);
  }

  retrieveAnswer(locale, changeHistory=true) {
    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
    this.props.root.setCurrentLocale(locale);
    this.props.root.changeStatus(this.props.parent.STATUS_VIEW_RETRIEVER());

    if(this.props.root.isAdminUser() || (this.props.root.getSameSchoolEdit() && locale.school_id == this.props.root.getMySchoolId()) || this.props.root.getMyUserId() == locale.user_id){
      // console.log('send set 11 req');
      this.props.root.refs.API.request('reset_epack_submission_new', {epack_id:locale.id});
      this.refreshLocaleList();
    }

    if (changeHistory) {
      this.props.root.pushHistory("locale/retriever/date", {locale: locale});
    }
  }

  deleteLocale(id) {
    this.setState({ localeID: id});
    this.state.localeID = id;
    let dialogText = {
      title: Localization.strings.DELETE_LOCALE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteLocaleConfirmClicked, this.deleteLocaleCancelClicked);
  }

  deleteLocaleConfirmClicked() {
    if (this.state.localeID >= 0) {
      let requestObj = {table: "epack",filter: { id: this.state.localeID }};
      this.props.root.refs.API.request("delete", requestObj, this.deleteLocaleOK, this.deleteLocaleFail);
    }
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleCancelClicked() {
    this.setState({ localeID: -1 });
    this.state.localeID = -1;
  }

  deleteLocaleOK(res) {
    this.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.DELETED, true);
  }

  deleteLocaleFail(err) {
    console.log("delete locale fail");
    this.props.root.addNotification(Localization.strings.DELETE_FAILED, false);
  }

  previousPage() {
    let page = this.state.currentPage;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePage(page);
  }

  nextPage() {
    let page = this.state.currentPage;
    page++;
    if (page > this.state.totalPage - 1) {
      page = this.state.totalPage - 1;
    }
    this.changePage(page);
  }

  changePage(page, refresh=true) {
    this.setState({ currentPage: page });
    this.state.currentPage = page;
    if (refresh) {
      this.refreshLocaleList();
    }
  }

  createMapTile(upperLeftLatLon, bottomRightLatLon) {
    MapTile.findAllTileDataList(upperLeftLatLon, bottomRightLatLon, this.findMapTileComplete);
    this.refs.progressDialog.show(null, this.createMapTileDone);
  }

  createMapTileDone() {
    if (this.refs.createLocaleDialog.state.open) {
      this.refs.createLocaleDialog.createMapTileDone();
    }
    if (this.refs.editLocaleDialog.state.open) {
      this.refs.editLocaleDialog.createMapTileDone();
    }
  }

  findMapTileComplete(length) {
    this.setState({tileLength: length});
    this.state.tileLength = length;
    this.refs.progressDialog.setDescription(Localization.strings.PREPARING + "... 0/" + this.state.tileLength);
    MapTile.downloadAllTileDataList(this.downloadMapTileComplete);
  }

  downloadMapTileComplete(count) {
    this.refs.progressDialog.setProgress(count / this.state.tileLength * 100.0);
    this.refs.progressDialog.setDescription(Localization.strings.PREPARING + "... " + count + "/" + this.state.tileLength);
    if (count == this.state.tileLength) {
      if (this.refs.createLocaleDialog.state.open) {
        this.refs.createLocaleDialog.downloadMapTileComplete();
      }
      if (this.refs.editLocaleDialog.state.open) {
        this.refs.editLocaleDialog.downloadMapTileComplete();
      }
    }
  }

  uploadMapTile(epackID, skip = false) {
    if(!skip){
      this.refs.progressDialog.setDescription(Localization.strings.UPLOADING + "...");
      this.refs.progressDialog.setProgress(0);
      this.refs.progressDialog.setVariant("indeterminate");
      MapTile.uploadAllTileDataList(epackID, this.uploadMapTileComplete);
    }else{
      this.refs.progressDialog.setDescription(Localization.strings.UPLOAD_COMPLETE);
      this.refs.progressDialog.setVariant("determinate");
      this.refs.progressDialog.showDoneButton();
    }
  }

  uploadMapTileComplete(progress) {
    this.refs.progressDialog.setProgress((1-progress) * 100.0);
    if (progress == 0) {
      this.refs.progressDialog.setDescription(Localization.strings.UPLOAD_COMPLETE);
      this.refs.progressDialog.setVariant("determinate");
      this.refs.progressDialog.showDoneButton();
    }
  }

  onViewAngleChanged(e) {
    let isPublic = false;
    switch (e.target.value) {
      case 0:
        isPublic = false;
        break;
      case 1:
        isPublic = true;
        break;
    }

    this.setState({ isViewPublic: isPublic });
    this.state.isViewPublic = isPublic;

    this.ChangeViewAnlge();
  }

  ChangeViewAnlge() {
    this.changePage(0, false);
    this.setState({
      filterSchoolID: (this.state.isViewPublic? null : this.props.root.getMySchoolId()),
      filterUserID: (this.state.isViewPublic? null : this.props.root.getMyUserId()),
    });
    this.state.filterSchoolID = (this.state.isViewPublic? null : this.props.root.getMySchoolId());
    this.state.filterUserID = (this.state.isViewPublic? null : this.props.root.getMyUserId());

    this.refs.localeViewerBar.clearFilter();
    if (!this.state.isViewPublic) {
      this.refs.localeViewerBar.setDefaultUserOption(this.state.filterUserID);
    }

    // no instant refresh (2025 version )
    // this.refreshLocaleList();

  }

  onQAStateChanged(e) {
    this.setState({ qaState: e.target.value });
    this.state.qaState = e.target.value;
    this.changePage(0, false);
    this.refreshLocaleList();
  }

  onClearFilter() {
    this.changePage(0, false);
    this.setState({
      filterKLA: null,
      filterSubject: null,
      filterKeyword: null,
    });
    this.state.filterKLA = null;
    this.state.filterSubject = null;
    this.state.filterKeyword = null;
  }

  updateLocalLocaleDataById(locale_id, localeData) {
    let tempLocaleList = this.state.localeList;
    let tempLocaleListInMap = this.state.localeListInMap;
    for (let i = 0; i < tempLocaleList.length; i++) {
      if (tempLocaleList[i]['id'] == locale_id) {
        tempLocaleList[i] = localeData;
      }
    }
    for (let i = 0; i < tempLocaleListInMap.length; i++) {
      if (tempLocaleListInMap[i]['id'] == locale_id) {
        tempLocaleListInMap[i] = localeData;
      }
    }
    this.setState({
      localeList: tempLocaleList,
      localeListInMap: tempLocaleListInMap,
    });
  }

  onResourceDuplicated() {
    this.setState({ needsRefresh: true });
  }

  render() {
      return (
        <div style={{display:(this.state.active ? "": "none")}}>
          
          <CreateLocaleDialog root={this.props.root} parent={this} ref="createLocaleDialog"/>
          <EditLocaleDialog root={this.props.root} parent={this} ref="editLocaleDialog"/>
          <LocaleOverviewDialog root={this.props.root} parent={this} ref="overviewLocaleDialog"/>
          <LocaleMapState root={this.props.root} parent={this} ref="localeMapState"/>
          <ProgressDialog root={this.props.root} parent={this} ref="progressDialog"/>

          <LocaleViewerBar root={this.props.root} parent={this} ref="localeViewerBar"/>
          
          
        <Box
          component="main"
          style={{
            marginLeft: `${localeBoxMarginLeft}px`,
            transition: 'margin .2s',
            position: 'relative',
            zIndex: 1055
          }}
        >
          
          {(() => {
            // Safety check: ensure props are available before rendering child components
            if (!this.props.root || !this.props.root.props) {
              return <div>Loading...</div>;
            }
            
            if (this.state.currentView === VIEW_LOCALE_LIST) {
              return <LocaleListView root={this.props.root} parent={this} ref="localListView"/>;
            } else if (this.state.currentView === VIEW_LOCALE_MAP) {
              return <LocaleMapView root={this.props.root} parent={this} ref="localeMapView"/>;
            } else if (this.state.currentView === VIEW_RESOURCE_LIBRARY) {
              return <ResourceLibraryPage root={this.props.root} parent={this} onResourceDuplicated={this.refreshLocaleList} />;
            }
            return null;
          })()}
        </Box>

        
          
        


          


        </div>
      )
  }
}

export default LocaleViewerPage;
